import { CourseStatus } from '@/lib/constants';

export const SKILL_PATHWAY_PATH = '/courses/skillpath/[skill-pathway-slug]' as const;

export function skillPathwayHref(
  pathwaySlug: string,
  courseSlug: string,
  courseTitle: string,
): string {
  const q = new URLSearchParams({ courseSlug, courseTitle });
  return `/courses/skillpath/${encodeURIComponent(pathwaySlug)}?${q.toString()}`;
}

export function skillPathwayRoute(
  pathwaySlug: string,
  courseSlug: string,
  courseTitle: string,
  minStatus?: number,
) {
  return {
    pathname: SKILL_PATHWAY_PATH,
    params: {
      'skill-pathway-slug': pathwaySlug,
      courseSlug,
      courseTitle,
      ...(minStatus != null &&
        minStatus !== CourseStatus.Published && {
          min_status: String(minStatus),
        }),
    },
  } as const;
}
